import { render, staticRenderFns } from "./PonEletronicoPrincipalMonitoramento.vue?vue&type=template&id=178952f4&"
import script from "./PonEletronicoPrincipalMonitoramento.vue?vue&type=script&lang=js&"
export * from "./PonEletronicoPrincipalMonitoramento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports